import { getFullName } from '@/utils/index.js';
import CommunicationMethod from '@/entities/CommunicationMethod.js';

export default {
    methods: {
        getLeadCommunicatingMessage(communicatingLead) {
            const userName = getFullName(communicatingLead?.communicating_user);

            return (
                {
                    [CommunicationMethod.PHONE]: this.$t(
                        'leadCommunicating.current.phone.description',
                        { userName }
                    ),
                    [CommunicationMethod.SMS]: this.$t(
                        'leadCommunicating.current.sms.description',
                        { userName }
                    ),
                    [CommunicationMethod.VIDEO]: this.$t(
                        'leadCommunicating.current.video.description',
                        { userName }
                    ),
                    [CommunicationMethod.EMAIL]: this.$t(
                        'leadCommunicating.current.email.description',
                        { userName }
                    ),
                }[communicatingLead?.communication_method_id] || ''
            );
        },

        getLeadCommunicatingIcon(communicatingLead) {
            return (
                {
                    [CommunicationMethod.PHONE]: 'regular/phone',
                    [CommunicationMethod.SMS]: 'regular/messages-bubble-typing-1',
                    [CommunicationMethod.VIDEO]: 'regular/meeting-camera',
                    [CommunicationMethod.EMAIL]: 'regular/email-action-unread',
                }[communicatingLead?.communication_method_id] || ''
            );
        },
    },
};
